import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=cfa7d75c&scoped=true"
import script from "./Contato.vue?vue&type=script&lang=js"
export * from "./Contato.vue?vue&type=script&lang=js"
import style0 from "./Contato.vue?vue&type=style&index=0&id=cfa7d75c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa7d75c",
  null
  
)

export default component.exports